<template>
  <div
    class="absolute top-[29px] left-[-79px] w-[101px] bg-grays-400 rounded-[5px] px-2 py-1 z-20 disable-font-variation"
  >
    <p class="text-grays-800 text-sm font-medium">3 ספרות בגב הכרטיס</p>
    <img
      class="absolute w-[19px] h-[11px] right-[5px] top-[-7.5px]"
      src="@/assets/icons/global/polygon-gray.svg"
      alt="Notification off"
    />
  </div>
</template>

<script>
export default {
  name: "tooltip-cvv",
};
</script>

<style>
.disable-font-variation {
  font-variation-settings: normal;
  direction: rtl;
  font-family: NotoSansHebrewNew, "Noto Sans Hebrew", sans-serif;
  white-space: normal;
}
</style>